"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function AddToCartDialogAlertView(props) {
  var open = props.open,
    onClose = props.onClose,
    alertMessage = props.alertMessage;
  var closeAlertModelTimer = 4000;
  var AlertDialog = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    open: open,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, /*#__PURE__*/_react.default.createElement(_core.DialogContent, {
    className: "alter-content"
  }, /*#__PURE__*/_react.default.createElement(_core.DialogContentText, {
    id: "alert-dialog-description"
  }, alertMessage))));
  if (open) {
    //  close the Dialog after 3 seconds.
    setTimeout(function () {
      onClose();
    }, closeAlertModelTimer);
  }
  return AlertDialog;
}
var _default = AddToCartDialogAlertView;
exports.default = _default;